<app-toast-container></app-toast-container>

@if (motd() && motd_msg()?.text && networkStatus() && isServerOk() && !maintenance()) {
  <div class="row">
    <div class="motd-container">
      <span class="motd-text">{{motd_msg()?.text}}</span>
      @if (motd_msg()?.btn_text && motd_msg()?.btn_link) {
        <span class="motd-text-link" (click)="handleMotdButton()">{{motd_msg()?.btn_text}}</span>
      }
    </div>
  </div>
}

@if (networkStatus() && isServerOk() && !maintenance()) {
  <router-outlet></router-outlet>
}

@if (!networkStatus() || !isServerOk() || maintenance()) {
  <div class="row h-100">
    <div class="col-10 offset-1 offset-lg-3 col-lg-6 card my-auto py-5">
      @if (!networkStatus()) {
        <div class="text-center">
          <span class="offline-title" translate="offline.offline-title"></span><br>
          <span class="offline-text" translate="offline.offline-text"></span><br>
        </div>
      }

      @if (!isServerOk() && networkStatus() && !maintenance()) {
        <div class="text-center">
          <img src="assets/header.png" height="64"><br><br>
          <span class="offline-title" translate="offline.offline-server-title"></span><br>
          <span class="offline-text" translate="offline.offline-server-text"></span><br>
          <button class="btn btn-primary offline-refresh-button btn-domusign-green mt-5" (click)="refresh()">
            @if (refreshing()) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }
            <span translate="offline.offline-server-retry-button"></span>
          </button>
        </div>
      }

      @if (maintenance() && networkStatus()) {
        <div class="row">
          <div class="text-center">
            <img src="assets/header.png" height="64"><br><br>
            <span class="text-center col-12 mt-4 offline-title" translate="maintenance.maintenance-title"></span><br>
            <span class="text-center col-12 mt-2 offline-text">{{maintenance_msg()?.[lang()]}}</span>
          </div>
        </div>
      }
    </div>
  </div>
}
